import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState
} from 'react';
import MenuOption from '~/constants/MenuOption';

type ContextType = {
  expandOnOpen: MenuOption;
  hasAppliedTrade: boolean;
  setExpandOnOpen: React.Dispatch<React.SetStateAction<MenuOption>>;
  setShowFinance: React.Dispatch<React.SetStateAction<boolean>>;
  showFinance: boolean;
  toggleAppliedTrade: () => void;
};

const defaultContext: ContextType = {
  expandOnOpen: MenuOption.None,
  hasAppliedTrade: false,
  setExpandOnOpen() {},
  setShowFinance() {},
  showFinance: false,
  toggleAppliedTrade() {}
};

const SearchContext = createContext<ContextType>(defaultContext);

export type OwnProps = React.PropsWithChildren<{
  hasAppliedTrade?: boolean;
  showFinance?: boolean;
}>;

// TODO potentially move other Search values here and out of AppliedFiltersContext
export function SearchContextProvider(props: OwnProps) {
  const [expandOnOpen, setExpandOnOpen] = useState(MenuOption.None);
  const [hasAppliedTrade, setAppliedTrade] = useState<boolean>(
    props.hasAppliedTrade ?? false
  );
  const [showFinance, setShowFinance] = useState(props.showFinance ?? false);

  const toggleAppliedTrade = useCallback(() => {
    setAppliedTrade(v => !v);
  }, []);

  const value = useMemo<ContextType>(
    (): ContextType => ({
      expandOnOpen,
      hasAppliedTrade,
      setExpandOnOpen,
      setShowFinance,
      showFinance,
      toggleAppliedTrade
    }),
    [expandOnOpen, hasAppliedTrade, showFinance, toggleAppliedTrade]
  );

  return (
    <SearchContext.Provider value={value}>
      {props.children}
    </SearchContext.Provider>
  );
}

SearchContextProvider.displayName = 'SearchContextProvider';

export function useHasAppliedTrade() {
  return useContext(SearchContext).hasAppliedTrade;
}

export default SearchContext;
